import React, { useState, useEffect } from "react";
import { Button, Icon, Modal, Tooltip } from "antd";
import { Link } from "react-router-dom";

import {
	PlayIcon,
	DeleteEventIcon,
	DraftIcon,
} from "../../../../../resource/icons";

import "./form-buttons.scss";
import useSaveValidation from "../../../hooks/useSaveValidation";
import usePlayValidation from "../../../hooks/usePLayValidation";

const FormButtons = ({
	onPlay,
	onSave,
	onDelete,
	onCancel,
	formValues,
	editing,
	bottom,
	withTimeout = false,
}) => {
	const { confirm } = Modal;
	const { questionsKeys = "", questions = [] } = formValues;
	const questionByKeys = questionsKeys.split(",").reduce((acc, key) => {
		if (key) {
			let answersByKeys = [];
			const question = questions[key];
			if (question?.answerKeys) {
				answersByKeys = question.answerKeys.split(",").reduce((acc, key) => {
					if (key) {
						acc[key] = question.answers[key];
					}

					return acc;
				}, []);
			}
			acc[key] = { ...questions[key], answers: answersByKeys };
		}
		return acc;
	}, []);

	const [playBtnLoading, setPlayBtnLoading] = useState(false);
	const [saveBtnLoading, setSaveBtnLoading] = useState(false);

	let saveTimeout = null;
	let playTimeout = null;

	useEffect(() => {
		return () => {
			clearTimeout(saveTimeout);
			clearTimeout(playTimeout);
		}
	}, []);

	const [playValidationSuccess, playValidationErrors] = usePlayValidation(
		formValues.title,
		formValues.description,
		formValues.period,
		formValues.addresses,
		questionByKeys
	);

	const [saveValidationSuccess, saveValidationErrors] = useSaveValidation(
		formValues.period,
		formValues.title
	);

	const handleSaveBtnClick = () => {
		if (withTimeout) {
			setSaveBtnLoading(true);
			saveTimeout = setTimeout(() => {
				onSave();
				setSaveBtnLoading(false);
			});
		} else {
			onSave();
		}
	};

	const handlePlayBtnClick = () => {
		if (withTimeout) {
			setPlayBtnLoading(true);
			saveTimeout = setTimeout(() => {
				onPlay();
				setPlayBtnLoading(false);
			});
		} else {
			onPlay();
		}
	};


	return (
		<div className={`form__buttons ${bottom ? "form__buttons-bottom" : ""}`}>
			<Tooltip
				title={
					playValidationErrors ? (
						<span style={{ maxWidth: "300px" }}>{playValidationErrors}</span>
					) : (
						`Опрос станет доступен жителям ${formValues.period?.[0]?.format(
							"DD.MM.YYYY в HH:mm"
						)}`
					)
				}
				placement={bottom ? "top" : "bottom"}
			>
				<Button
					onClick={playValidationSuccess ? handlePlayBtnClick : () => {}}
					className={`play button ${
						playValidationSuccess ? "" : "button-disabled"
					}`}
					disabled={playBtnLoading}
				>
					<PlayIcon />
					<span>Запустить опрос</span>
				</Button>
			</Tooltip>
			
				<Tooltip
					title={
						saveValidationErrors ? (
							<div style={{ maxWidth: "300px" }}>{saveValidationErrors}</div>
						) : null
					}
					placement="bottom"
				>
					<Button
						className={`save button ${
							saveValidationSuccess ? "" : "button-disabled"
						}`}
						onClick={saveValidationSuccess ? handleSaveBtnClick : () => {}}
						disabled={saveBtnLoading}
					>
						<DraftIcon />
						<span>Сохранить</span>
					</Button>
				</Tooltip>
			{
				<Button
					className="delete button"
					onClick={() => {
						confirm({
							title: "Вы уверены, что хотите удалить опрос",
							okText: "Да",
							okType: "danger",
							cancelText: "Нет",
							onOk() {
								onDelete();
							},
						});
					}}
				>
					<DeleteEventIcon />
					<span>Удалить</span>
				</Button>
			}
			{editing && (
				<Link to={`/Voting/${editing}`} className="cancel button">
					<Button className="cancel button" onClick={onCancel}>
						<Icon type="arrow-left" />
						<span>Отмена</span>
					</Button>
				</Link>
			)}
		</div>
	);
};

export default FormButtons;
